import serverVars from 'server-vars';
import { useEffect } from 'react';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes.ts';

import { getDwelledOnPage, setDwelledOnPageFlag } from '../helpers/loginPromptHelpers.ts';

const DWELL_ON_PDP_LIMIT_DESKTOP = 22000;
const DWELL_ON_PDP_LIMIT_MOBILE = 19000;

const DWELL_ON_HOMEPAGE_LIMIT = 11000;

const DWELL_ON_SB_LIMIT_DESKTOP = 28000;
const DWELL_ON_SB_LIMIT_MOBILE = 27000;

export type DwellPageType = typeof PAGE_TYPE.HOME | typeof PAGE_TYPE.SEARCH | typeof PAGE_TYPE.PDP;

const handleDwellTimeout = (pageType: DwellPageType): void => {
    setDwelledOnPageFlag(pageType);
};

export const setDwelledOnPage = (
    pageType: DwellPageType,
    dwellTimeOverride?: number
): NodeJS.Timeout | undefined => {
    if (!getDwelledOnPage(pageType)) {
        const isMobile = serverVars.get('settings.isMobile');
        let dwellTimeLimit;

        if (dwellTimeOverride) {
            dwellTimeLimit = dwellTimeOverride;
        } else {
            switch (pageType) {
                case PAGE_TYPE.PDP:
                    dwellTimeLimit = isMobile
                        ? DWELL_ON_PDP_LIMIT_MOBILE
                        : DWELL_ON_PDP_LIMIT_DESKTOP;
                    break;
                case PAGE_TYPE.HOME:
                    dwellTimeLimit = DWELL_ON_HOMEPAGE_LIMIT;
                    break;
                case PAGE_TYPE.SEARCH:
                    dwellTimeLimit = isMobile
                        ? DWELL_ON_SB_LIMIT_MOBILE
                        : DWELL_ON_SB_LIMIT_DESKTOP;
                    break;
            }
        }

        return setTimeout(() => handleDwellTimeout(pageType), dwellTimeLimit);
    }
    return undefined;
};

export const useDwelledOnPage = (pageType: DwellPageType, dwellTimeOverride?: number): void => {
    useEffect(() => {
        const timeoutId = setDwelledOnPage(pageType, dwellTimeOverride);
        return () => clearTimeout(timeoutId);
    }, [pageType, dwellTimeOverride]);
};
